import { createCollection } from '@rocketlane/state-db';
import { taskCollection } from 'collections/tasks';
import { converToEntityId, PhaseEntityType } from 'data/projects/phase-entity';
/** Stable serialization of the plan filters for lane identity. */ export const getPlanFiltersHash = (filters)=>{
    var _ref, _ref1, _ref2, _ref3;
    return JSON.stringify([
        (_ref = filters === null || filters === void 0 ? void 0 : filters.completed) !== null && _ref !== void 0 ? _ref : null,
        (_ref1 = filters === null || filters === void 0 ? void 0 : filters.responsibleCompanyIds) !== null && _ref1 !== void 0 ? _ref1 : [],
        (_ref2 = filters === null || filters === void 0 ? void 0 : filters.includePrivate) !== null && _ref2 !== void 0 ? _ref2 : true,
        (_ref3 = filters === null || filters === void 0 ? void 0 : filters.budgetIds) !== null && _ref3 !== void 0 ? _ref3 : []
    ]);
};
export const getPlanLaneKey = (projectId, phaseId, filters)=>`${projectId}:${phaseId}:${getPlanFiltersHash(filters)}`;
export const planLaneCollection = createCollection({
    id: 'plan-lanes',
    getKey: (lane)=>lane.laneKey,
    indexes: {
        byProject: (lane)=>lane.projectId,
        byPhase: (lane)=>lane.projectPhaseId
    }
});
export const planBoardPhaseCollection = createCollection({
    id: 'plan-board-phases',
    getKey: (entry)=>entry.projectPhaseId,
    indexes: {
        byProject: (entry)=>entry.projectId
    }
});
/**
 * Dead-token reconciler: when a task is removed from `taskCollection`
 * (delete, WS externalDelete), strip its token from every lane that still
 * references it — one central fixup instead of per-call-site cleanup. Extra
 * safety net only: rendering already skips tokens with no matching entity,
 * and membership truth always comes back via lane refetch.
 */ let reconcilerAttached = false;
export const attachPlanLaneReconciler = ()=>{
    if (reconcilerAttached) {
        return;
    }
    reconcilerAttached = true;
    taskCollection.subscribeToChanges((changedIds)=>{
        const deadTokens = new Set();
        changedIds.forEach((id)=>{
            if (taskCollection.get(id) === undefined && typeof id === 'number') {
                deadTokens.add(converToEntityId(id, PhaseEntityType.Task));
            }
        });
        if (deadTokens.size === 0) {
            return;
        }
        const lanesToPatch = planLaneCollection.getAll().filter((lane)=>lane.pageTokens.some((token)=>deadTokens.has(token)));
        if (lanesToPatch.length === 0) {
            return;
        }
        planLaneCollection.push(lanesToPatch.map((lane)=>({
                ...lane,
                pageTokens: lane.pageTokens.filter((token)=>!deadTokens.has(token))
            })));
    });
};
